import { Box, Button, CardActions, CardHeader, Chip, Collapse, Divider, Drawer, Grid, Stack, Typography } from '@mui/material';
import CusDataGrid from 'components/CusDataGrid';
import CusFormField from 'components/CusFormField';
import MainCard from 'components/MainCard';
import useMain from 'hooks/useMain';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { BC_TYPE } from './constant';
import { moduleDetailsFields, detailsWorkflowFields } from './field';
import CusDrawer from 'components/CusDrawer';
import { sharedDetailGridColumns } from './column/table-columns';
import { SidebarForm } from './component';
import { errorHandling, handleAlertMessage, handleAsyncCall, OptionUtils, toDefaultMicDateFormat } from 'utils/common';
import { micService } from 'services/mic';
import { rFetchCategories, rFetchFloors, rFetchLocations, rFetchRegions, setState } from 'store/reducers/comModule';
import { useData, useFetchData } from './hook/useData';
import CusModal from 'components/CusModal';
import AuditTrail from './component/audit-trail';
import _ from 'lodash';
import moment from 'moment';
import { useTheme } from '@mui/material/styles';
import CustDetail from 'components/CusDetail';

const ModuleLayoutDetails = () => {
  const { t, useLocation, useSelector, upperCaseLang, project, dispatch } = useMain();
  const defaultValues = {};
  const location = useLocation();
  const [showAuditTrails, setShowAuditTrails] = useState(false);
  const [preview, setPreview] = useState(false);
  const [auditTrails, setAuditTrails] = useState([]);
  const [currentStepCode, setCurrentStepCode] = useState('');
  const [allowFields, setAllowFields] = useState([]);
  const [currentPortion, setCurrentPortion] = useState('');

  useFetchData({});

  const {
    categoryOptions,
    subCategoryOptions,
    blockOptions,
    floorOptions,
    unitOptions,
    selectedRegion,
    selectedFloor,
    concreteOptions,
    targetTypeSteps,
    rsCompanyOptions,
    currentBctype,
    setSelectedFloor,
    setSelectedRoom,
    selectedRoom,
    steps,
    setSelectedRegion
  } = useData({});

  const detailId = useLocation().state?.id;
  const [details, setDetails] = useState({});
  const theme = useTheme();

  const targetTypeStepsWithComplete = useMemo(
    () =>
      targetTypeSteps.map((step) => ({
        IsCompleted: !!details[`IsCompleted${step?.Portion}`],
        ...step
      })),
    [targetTypeSteps, details]
  );

  const fetchDetail = () => {
    if (project?.ProjId) {
      handleAsyncCall({
        service: micService.getRfidDetail,
        params: { id: detailId, projid: project?.ProjId },
        successCb: (res) => {
          const _detailEntries = Object.entries(res.data[0]).map(([key, value]) => {
            if (key.match(/Date/gi)) {
              return [key, toDefaultMicDateFormat(value)];
            }
            return [key, value];
          });

          const details = Object.fromEntries(_detailEntries);

          setDetails(details);
          setSelectedFloor(details.Floor);
          setSelectedRegion(details.Region);
          setSelectedRoom(details.RoomNo);
        }
      });
    }
  };

  const onSubmit = async (data) => {
    const dataEntries = Object.entries({
      ...data,
      Remark: data[`Remark${currentPortion}`],
      IsCompleted: data[`IsCompleted${currentPortion}`]
    });
    const modifiedDataEntries = dataEntries.map(([key, value]) => {
      if (_.isBoolean(value)) {
        return [key, value ? 1 : 0];
      }
      return [key, value];
    });

    const newData = Object.fromEntries(modifiedDataEntries);
    const params = {
      StepCode: currentStepCode,
      Data: { Id: detailId, ...newData }
    };
    handleAsyncCall({
      service: micService.modifyRfidStepDetails,
      params,
      showSuccessAlert: true,
      successCb: (res) => {
        setAuditTrails([]);
        fetchDetail();
        setOpenSidebar(false);
        setShowAuditTrails(false);
      }
    });
  };

  useEffect(() => {
    if (project?.ProjId) {
      fetchDetail();
    }
  }, [project?.ProjId]);

  const getFieldsInfo = moduleDetailsFields({ t, type: currentBctype, upperCaseLang });
  return (
    <Stack spacing={2}>
      <CustDetail
        details={details}
        summaryFieldsLabel={getFieldsInfo}
        summaryShowField={[
          'ContractNo',
          `ContractDesc${upperCaseLang}`,
          `ContractorName${upperCaseLang}`,
          `ManufacturerName${upperCaseLang}`,
          `ManufacturerAddress${upperCaseLang}`,
          'TagId',
          'Bctype',
          'RfidtagNo',
          'ASN'
        ]}
        summaryDetailId={detailId}
        summaryFetchDetail={fetchDetail}
        targetTypeStepsWithComplete={targetTypeStepsWithComplete}
        // setOpenSidebar={setOpenSidebar}
      />
    </Stack>
  );
};

export default ModuleLayoutDetails;
